/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qr_Pickup_TitleInputs */

const vi_qr_pickup_title = /** @type {(inputs: Qr_Pickup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quét QR nhận đơn`)
};

/**

* @param {Qr_Pickup_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const qr_pickup_title = /** @type {((inputs?: Qr_Pickup_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qr_Pickup_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_qr_pickup_title(inputs)
});